<template>
    <div>
        <attached-fs-modal ref="fs-modal"></attached-fs-modal>
        <ui-crud title="Progress reports" subtitle="All Progress Reports for this package"
                 ref="crud"
                 :fetch="fetch" :pipe-with="pipeItems">

            <template #new-button>
                <div class="flex items-center">
                    <h1 class="text-lg font-medium text-gray-900">Progress reports</h1>
                    <ui-button-new small class="ml-auto hidden sm:inline-flex" icon="fas fa-plus"
                                   @click.prevent="createNew()">New
                    </ui-button-new>
                </div>
                <p class="mt-1 text-sm text-gray-600">All Progress Reports for this package</p>
                <ui-button-new class="sm:hidden mt-4" icon="fas fa-plus"
                               @click.prevent="createNew()">New
                </ui-button-new>
            </template>

            <!-- Filters. -->
            <template #filters>
                <div class="relative">
                    <ui-input class="mt-6" field="bg-gray-50 pr-10" name="search" v-model="search"></ui-input>
                    <div class="absolute right-0 inset-y-0 h-full flex items-center justify-center p-3 text-gray-400">
                        <i class="fas fa-search"></i>
                    </div>
                </div>
            </template>

            <!-- List item. -->
            <template #list-item="{ item, select, active, setEditMode }">
                <ui-crud-card
                    :titleAsHtml="getItemTitle(item)"
                    :subtitle="`${item.createdBy}`"
                    :metadata="`${item.progressPercent}%`"
                    :active="active"
                    @click="selectItem(item,select,setEditMode)"
                ></ui-crud-card>
            </template>

            <!-- Create form. -->
            <template #create="{ addItem, setEditMode, selectItem }">
                <div class="flex space-x-8 pt-4 px-4 m-4 justify-center items-center">
                    <div
                        class="border border-grey-200 rounded-l bg-gray-50 w-full h-full p-4 justify-center items-center text-center text-gray-500">
                        <-- Please select an existing Progress Report to view/edit or click new to create a new one.
                        <div v-if="noContract" class="text-red-600 mt-4 ">
                            No Contract/Component buildup has been found for this package!
                        </div>
                    </div>
                </div>
            </template>

            <template #edit="{ selectedItem, setEditMode, removeItem }">
                <progress-report-edit :progressId="selectedItem.id"
                                      :item="selectedItem"
                                      :remove-item="removeItem"
                                      :fs-modal="$refs['fs-modal']"
                                      @statusChanged="statusChanged"
                ></progress-report-edit>
            </template>

            <!-- Show page. -->
            <template #show="{ selectedItem, setEditMode, removeItem, addItem, selectItem }">
                <progress-report-show :package-reference="packageReference" :package-name="packageName"
                                      :progressId="selectedItem.id" :item="selectedItem"
                                      :readonly="true"
                                      :fs-modal="$refs['fs-modal']"></progress-report-show>
            </template>
        </ui-crud>
    </div>
</template>

<script>

import {ProgressReport} from "@models";
import ProgressReportShow from "./ProgressReportShow.vue";
import AttachedFsModal from "../filesystem/AttachedFsModal.vue";
import UiButtonNew from "../ui/UiButtonNew.vue";
import {uuid} from "../../utils";

export default {
    components: {UiButtonNew, AttachedFsModal, ProgressReportShow},
    props: {
        packageReference: null,
        packageName: null,
        admin: Boolean,
    },
    computed: {},
    data() {
        return {
            search: '',
            noContract: false,
        }
    },
    methods: {
        async createNew() {
            let id = uuid();
            this.noContract = false;
            try {
                await ProgressReport.create(this.packageReference, id)
                await this.$refs.crud.fetchItems();
                this.$refs.crud.selectItem(this.$refs.crud.items.find((i) => i.id === id), true);
            } catch (error) {
                let body = JSON.parse(error.request.response);
                if (body.message.startsWith('No Component buildup found for package')) {
                    this.noContract = true;
                }
            }
        },
        async statusChanged(item, progress) {
            let crud = this.$refs.crud;
            crud.selectItem(this.$refs.crud.items.find((i) => i.id === item.id), progress.status === 'Draft');
        },
        getItemTitle(item) {
            if (item.status === 'Draft') {
                return '<span class="text-gray-400">Draft #' + item.referenceNumber + '</span> - ' + item.formatted_date;
            }
            return '#' + item.referenceNumber + ' - ' + item.formatted_date;
        },
        selectItem(item, select, setEditMode) {
            select()
            if (item.status === 'Draft') {
                setEditMode(true)
            } else {
                setEditMode(false)
            }
        },
        async fetch() {
            return await ProgressReport.list(this.packageReference)
        },
        pipeItems(items) {
            const query = this.search.toLowerCase().split(/[^A-Za-z0-9.-]+/);
            if (query.length) {
                return items.filter((pr) => {
                    return query.every((token) => {
                        return pr.tokens.includes(token);
                    })
                });
            }
            return items;
        },
    },
}
</script>
